<form [formGroup]="containerSettingsForm">
  <div class="touch-table__table-wrapper mxn3 mtn2 pb5 px1 bg-gray-93 assign-item-modal-container-height">
    <div class="touch-table border-bottom-0 border-top-0 border-left-0 border-right-0">
      <table id="positionSettingsTable">
        <thead>
          <tr>
            <th class="left">Description</th>
            <th class="left">Value</th>
          </tr>
        </thead>
        <tbody id="ruleTable{{this.pagingConfig.currentPage}}">
          @for (rule of filteredRules | displayToUserPipe | paginate: pagingConfig; track trackItem(i, rule); let i = $index) {
            <tr id="ruleContainerRow{{i}}">
              <td class="h4 bold">
                {{rule.rule.name}}
                @if (showWitnessAlert(rule)) {
                  <div id="divWitnessAlert" class="flex align-center">
                    <svg class="h5 fill-warning-dark">
                      <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
                    </svg>
                    <div id="divWitnessAlertMessage" class="h5 gray-40 normal pl1">This setting cannot be enabled if dispense type is Under Hood
                      and/or
                      until quantity is removed from Under Hood.</div>
                  </div>
                }
              </td>
              @if (ruleIsBool(rule)) {
                <td id="booleanRuleId{{rule.ruleId}}" nc-boolean-rule [rule]="rule" [rulesFormGroup]="containerSettingsForm"
                  [isEditAuthorized]="isEditAuthorized" [controlName]="getFormControlName(rule)"
                  [controlSliderWrapperName]="getFormControlSliderWrapperName(rule)" [disableRule]="rule.isDisabled" [isChecked]="rule.booleanValue">
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <ul id="containerRulesModalPagination" class="touch-pagination bg-gray-93 myn1">
      <div nc-pagination-controls [config]="pagingConfig"></div>
    </ul>
  </div>
</form>
